/**
 * Intl Tel Input directive
 *
 * Base taken from https://github.com/hodgepodgers/ng-intl-tel-input/blob/master/dist/ng-intl-tel-input.js,
 * but we needed to adjust and extend it since API, requirements and usage changed
 *
 */
angular.module('common.directives.ngIntlTelInput', []);
angular.module('common.directives.ngIntlTelInput').provider('ngIntlTelInput', function () {
    let me = this;

    /**
     * Helper function to extend props object
     * @param props
     * @param newProps
     * @returns props
     */
    this.setProps = function (props, newProps) {
        if (typeof newProps !== 'object') {
            return props;
        }
        let result = angular.copy(props);
        for (let key in newProps) {
            result[key] = newProps[key];
        }
        return result;
    }

    let defaultProps = {};
    this.set = function (newProps) {
        defaultProps = this.setProps(defaultProps, newProps);
    };

    this.$get = ['$log', function ($log) {
        return Object.create(me, {
            init: {
                value: function (elm, props) {
                    props = this.setProps(defaultProps, props);
                    return window.intlTelInput(elm[0], props);
                }
            },
        });
    }];
});
angular.module('common.directives.ngIntlTelInput').directive('ngIntlTelInput', ['ngIntlTelInput', '$log', '$window', '$parse',
    function (ngIntlTelInput, $log, $window, $parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                preferredCountries: '=',
                localizedCountries: '=',
                onlyCountries: '=',
                initialCountry: '=',
                currentValue: '=',
                intlTelInstance: '=',
            },
            link: function (scope, elm, attr, ctrl) {
                // Warning for bad directive usage.
                if ((!!attr.type && (attr.type !== 'text' && attr.type !== 'tel')) || elm[0].tagName !== 'INPUT') {
                    $log.warn('ng-intl-tel-input can only be applied to a *text* or *tel* input');
                    return;
                }

                let props = {};
                // Override default country.
                if (scope.initialCountry) {
                    props = ngIntlTelInput.setProps(props, {initialCountry: scope.initialCountry});
                }
                if (scope.localizedCountries) {
                    props = ngIntlTelInput.setProps(props, {localizedCountries: scope.localizedCountries});
                }
                if (scope.preferredCountries) {
                    props = ngIntlTelInput.setProps(props, {countryOrder: scope.preferredCountries});
                }
                if (scope.onlyCountries) {
                    props = ngIntlTelInput.setProps(props, {onlyCountries: scope.onlyCountries});
                }

                // 🔹 Added for intl-tel-input v25: disable search + load utils as ES module
                props = ngIntlTelInput.setProps(props, {
                    countrySearch: false,
                    loadUtils: () => {
                        return new Promise((resolve, reject) => {
                            // Check if already loaded
                            if (window.__intlTelInputUtils) {
                                resolve(window.__intlTelInputUtils);
                                return;
                            }

                            // Create a module script that imports the utils
                            const script = document.createElement('script');
                            script.type = 'module';
                            script.textContent = `
                                import * as utils from '/assets/app/javascripts/gulp/intl-tel-input-utils.js';
                                window.__intlTelInputUtils = utils;
                                window.dispatchEvent(new CustomEvent('intlTelInputUtilsLoaded', { detail: utils }));
                            `;

                            // Listen for when the module finishes loading
                            window.addEventListener('intlTelInputUtilsLoaded', function handler(event) {
                                window.removeEventListener('intlTelInputUtilsLoaded', handler);
                                resolve(event.detail);
                            }, {once: true});

                            script.onerror = (error) => {
                                reject(error);
                            };

                            document.head.appendChild(script);
                        });
                    }
                });

                // Initialize.
                // timeout: this is shit! The problem is after leaving the page and navigating back, the number was wrongly formatted (in intl format)
                setTimeout(function () {
                    let intlInstance = ngIntlTelInput.init(elm, props);
                    if (typeof scope.intlTelInstance !== 'undefined') {
                        scope.intlTelInstance = intlInstance;
                    }
                    // Cleanup.
                    function cleanUp() {
                        intlInstance.destroy();
                    }
                    scope.$on('$destroy', cleanUp);

                    // 🔹 Helper function for setting up listeners & validation (runs after promise if needed)
                    function setupBindings() {
                        //change of the country triggers also model update
                        elm[0].addEventListener("countrychange", function() {
                            ctrl.$setViewValue(intlInstance.getNumber());
                            scope.$applyAsync();
                        });
                        if (typeof scope.currentValue !== 'undefined') { //update current value (even if it's not valid)
                            elm[0].addEventListener("change", function() {
                                scope.currentValue = intlInstance.getNumber();
                                scope.$applyAsync();
                            });
                        }

                        // Validation.
                        ctrl.$validators.ngIntlTelInput = function (value) {
                            // if phone number is deleted / empty do not run phone number validation
                            if (value || elm[0].value.length > 0) {
                                return intlInstance.isValidNumber();
                            } else {
                                return true;
                            }
                        };

                        // Set model value to valid, formatted version.
                        ctrl.$parsers.push(function (value) {
                            return intlInstance.getNumber();
                        });

                        // Set input value to model value and trigger evaluation.
                        ctrl.$formatters.push(function (value) {
                            if (value) {
                                if (value.charAt(0) !== '+') {
                                    value = '+' + value;
                                }
                                intlInstance.setNumber(value);
                            }
                            return value;
                        });
                    }

                    // 🔹 Support async initialization in intl-tel-input v25
                    if (intlInstance.promise) {
                        intlInstance.promise.then(setupBindings);
                    } else {
                        setupBindings();
                    }
                }, 50);

            }
        };
    }]);
